export default "__VITE_ASSET__01073053__"